var deleteButtonClasses = "inline-flex cursor-pointer items-center justify-center rounded-md border border-transparent px-3 py-2 text-sm font-medium bg-transparent border-0 p-0 text-rose-600 ml-auto RemoveHMOPlan";
var inputClasses = "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-meclinic-teal focus:ring-meclinic-teal text-sm px-2 py-1";

function hmoPlansData($form) {
  var data = $form.data('hmos');

  if (Array.isArray(data)) {
    return data;
  }

  if (typeof data === 'string' && data.length > 0) {
    try {
      return JSON.parse(data);
    } catch (error) {
      return [];
    }
  }

  return [];
}

function undo_delete_hmo_plan(e) {
  e.preventDefault();
  var id = $(e.currentTarget).attr('id');
  var row = $('tr#tr-' + id);

  if (row.length > 0) {
    $(e.currentTarget).closest('.undo-delete-alert').remove();
    row.show('slow');
    row.find('input[type=hidden]').val('false');
  }
}

function add_hmo_plan_alert(id) {
  var alert_element = document.createElement('div');
  alert_element.classList.add('undo-delete-alert', 'flex', 'items-center', 'gap-3', 'rounded-md', 'border', 'border-blue-200', 'bg-blue-50', 'p-3', 'text-sm', 'text-blue-900', 'mb-3');

  var message = document.createElement('div');
  message.classList.add('flex-1');
  message.appendChild(document.createTextNode('An HMO plan was deleted. '));

  var undo = document.createElement('a');
  undo.href = '#';
  undo.id = id;
  undo.classList.add('font-medium', 'text-meclinic-teal', '', 'js-undo-hmo-plan-delete', 'hover:text-meclinic-teal-dark');
  undo.appendChild(document.createTextNode('undo'));

  var closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.classList.add('text-gray-400', 'hover:text-gray-600');
  closeButton.setAttribute('aria-label', 'Close');
  closeButton.innerHTML = '&times;';
  closeButton.addEventListener('click', function() {
    alert_element.remove();
  });

  message.appendChild(undo);
  alert_element.appendChild(message);
  alert_element.appendChild(closeButton);

  $('.hmo-plans-alerts').append(alert_element);
}

function remove_hmo_plan(event) {
  event.preventDefault();
  var id = new Date().getTime();
  var $row = $(event.currentTarget).closest('tr.hmo_plan_fields');

  $(event.currentTarget).next('input[type=hidden]').val('1');
  $row.hide();
  $row.attr('id', 'tr-' + id);
  add_hmo_plan_alert(id);
}

function add_hmo_plan(event) {
  event.preventDefault();

  var $form = $(event.currentTarget).closest('.js-patient-hmo-plans');
  var hmos = hmoPlansData($form);
  var newId = new Date().getTime();
  var options = hmos.map(function(hmo) {
    var safeName = (hmo.name || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    return "<option value='" + hmo.id + "'>" + safeName + "</option>";
  }).join('');

  var content = [
    "<tr class='hmo_plan_fields'>",
    "<td class='p-2'><select class='" + inputClasses + "' name='patient[hmo_patients_attributes][new_hmo_patient][hmo_id]' id='patient_hmo_patients_attributes_new_hmo_patient_hmo_id'>" + options + "</select></td>",
    "<td class='p-2'><input class='" + inputClasses + "' type='text' name='patient[hmo_patients_attributes][new_hmo_patient][plan]' id='patient_hmo_patients_attributes_new_hmo_patient_plan'></td>",
    "<td class='p-2'><input class='" + inputClasses + "' type='text' name='patient[hmo_patients_attributes][new_hmo_patient][number]' id='patient_hmo_patients_attributes_new_hmo_patient_number'></td>",
    "<td class='p-2'><input class='" + inputClasses + " datepicker' type='text' name='patient[hmo_patients_attributes][new_hmo_patient][expiry]' id='patient_hmo_patients_attributes_new_hmo_patient_expiry'></td>",
    "<td class='p-2'><input class='" + inputClasses + "' type='text' name='patient[hmo_patients_attributes][new_hmo_patient][notes]' id='patient_hmo_patients_attributes_new_hmo_patient_notes'></td>",
    "<td class='p-2'><div class='" + deleteButtonClasses + "'><i class='fa fa-fw fa-trash-o mr-1'></i> Delete</div><input type='hidden' value='false' name='patient[hmo_patients_attributes][new_hmo_patient][_destroy]' id='patient_hmo_patients_attributes_new_hmo_patient__destroy'></td>",
    "</tr>"
  ].join('');

  var regexp = new RegExp('new_hmo_patient', 'g');

  $('table.hmo_plans').append(content.replace(regexp, newId));
  if (window.initDatepickers) {
    window.initDatepickers($, $('table.hmo_plans tr:last'));
  } else {
    console.error('window.initDatepickers is not defined; datepickers will not initialize on new rows. Ensure legacy.js is loaded before this module.');
  }
}

$(function() {
  $('body').on('click', '.RemoveHMOPlan', remove_hmo_plan);
  $('body').on('click', '.AddHMOPlan', add_hmo_plan);
  $('body').on('click', '.js-undo-hmo-plan-delete', undo_delete_hmo_plan);
});
